<template>
  <div>
    <v-container fluid grid-list-md style="padding: 30px;">
      <v-row dense v-if="user.tipo == 'ADMIN_PRODUTORA'">
        <v-col cols="12" sm="12" md="6">
          <v-select
            outlined
            dense
            v-model="lojistaSelecionado"
            :items="lojistas"
            item-text="nome"
            item-value="id"
            label="Selecione o lojista"
            @input="carregaTransacoes"
          ></v-select>
        </v-col>
      </v-row>
      <v-layout row wrap>
        <v-flex xs12 sm12 lg2>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedInicio"
                label="Data Inicio"
                persistent-hint
                append-icon="event"
                @blur="date = parseDate(dateFormattedInicio)"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm12 lg1>
          <v-text-field
            v-model="horaInicio"
            label="Hora Início"
            light
            type="time"
            outlined
            dense
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 lg2>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedFim"
                label="Data Fim"
                persistent-hint
                append-icon="event"
                @blur="date = parseDate(dateFormattedFim)"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm12 lg1>
          <v-text-field
            v-model="horaFim"
            label="Hora Fim"
            light
            type="time"
            outlined
            dense
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 lg1>
          <v-btn dark @click="carregaTransacoes" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
        </v-flex>
      </v-layout>
      <v-row>
        <v-col ls="12" sm="12" md="12" lg="12">
          <v-data-table
            :search="tabela.busca"
            :headers="tabela.cabecalho"
            :items="tabela.conteudo"
            flat
            style="border-radius: 10px;"
            :loading="tabela.carregamento"
            loading-text="Aguarde, buscando transações..."
          >
            <template v-slot:top>
              <v-toolbar flat color="white" style="border-radius: 10px;">
                <v-toolbar-title class="textoUser">CONSUMOS</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="tabela.busca"
                  append-icon="search"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-toolbar>
            </template>
            <template slot="no-data">
              <v-row>
                <v-col>
                  <v-alert style="margin-top: 16px" dark dense text outlined :value="true" color="warning" icon="info">Nenhum consumo encontrado</v-alert>
                </v-col>
              </v-row>
            </template>
            <template slot="no-results">
              <v-row>
                <v-col>
                  <v-alert style="margin-top: 16px" dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
                </v-col>
              </v-row>
            </template>
            <template slot="body.append">
              <tr>
                <td :colspan="tabela.cabecalho.length">
                  <h2 style="margin: 0 auto; text-align: center">Total: {{ campoSoma('valor').toString().replace('.',',') }}</h2>
                </td>
              </tr>
            </template>
            <template v-slot:[`item.valor`]="{ item }">
              R$ {{ item.valor }}
            </template>
            <template v-slot:[`item.atendente.nome?`]="{ item }">
              {{ item.atendente == undefined ? formatarCanalPedido(item.canalPedido) : item.atendente.nome}}
            </template>
            <template v-slot:[`item.created`]="{ item }">
              {{ formatDateHour(item.created) }}
            </template>
            <template v-slot:[`item.tipoTransacao`]="{ item }">
              <v-chip :color="item.tipoTransacao == 'CONSUMO' ? 'green' : 'orange'" dark>{{ item.tipoTransacao }}</v-chip>
            </template>
            <template v-slot:[`item.consumidor.nome`]="{ item }">
              {{ item.consumidor && item.consumidor.nome ? item.consumidor.nome : 'Consumidor removido' }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon @click="exibeDetalhes(item)" color="#01579B">mdi-details</v-icon>
                  </v-btn>
                </template>
                <span>Detalhes</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" :disabled="item.estornado || item.tipoTransacao !== 'CONSUMO'" @click="abreConfirmacaoEstorno(item)">
                    <v-icon :color="item.estornado ? 'grey' : 'orange'">mdi-cash-refund</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.estornado ? 'Já estornado' : 'Estornar' }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="enviarMensagem(item.id)">
                    <v-icon color="purple">mdi-message-text</v-icon>
                  </v-btn>
                </template>
                <span>Enviar Mensagem</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <template>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab v-on="on" dark @click="generatePDF" color="primary">
                    <v-icon large>arrow_circle_down</v-icon>
                  </v-btn>
                </template>
                <span>Gerar PDF</span>
              </v-tooltip>
          </template>
          <template>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab v-on="on" dark @click="generatePDFDetails" color="#388E3C">
                    <v-icon large>mdi-details</v-icon>
                  </v-btn>
                </template>
                <span>Gerar PDF Detalhado</span>
              </v-tooltip>
          </template>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogoDetalhesConsumo" persistent max-width="400px" scrollable>
          <v-card>
            <v-card-title>Detalhes do consumo</v-card-title>
            <v-card-text style="padding-top: 10px">
              <v-row dense>
                <v-col cols="12">
                  <p style="margin: 0px"><span style="font-weight: bold">Lojista:</span> {{ detalhesCompra.lojista.nome }}</p>
                </v-col>
                <v-col cols="12">
                  <p style="margin: 0px"><span style="font-weight: bold">Atendente:</span> {{ detalhesCompra.atendente && detalhesCompra.atendente.nome !== undefined ? detalhesCompra.atendente.nome : 'Delivery' }}</p>
                </v-col>
                <v-col cols="12">
                  <p style="margin: 0px"><span style="font-weight: bold">Aluno:</span> {{ detalhesCompra.consumidor && detalhesCompra.consumidor.nome ? detalhesCompra.consumidor.nome : 'Consumidor removido' }}</p>
                </v-col>
                <v-col cols="12">
                  <p style="margin: 0px"><span style="font-weight: bold">Turma:</span> {{ detalhesCompra.consumidor && detalhesCompra.consumidor.turma ? detalhesCompra.consumidor.turma : 'Consumidor removido' }}</p>
                </v-col>
                <v-col cols="12">
                  <p style="margin-bottom: 5px">Itens adquiridos:</p>
                  <v-divider></v-divider>
                  <v-list dense v-for="item in detalhesCompra.itens" :key="item.produtoId" style="padding: 0px">
                    <v-list-item style="padding: 0px">
                      <v-list-item-content style="padding: 0px">
                        <v-list-item-title>{{ item.quantidade == undefined ? 0 : item.quantidade }}x {{ item.descricao === '' ? 'Compra Avulsa' :  item.descricao}}</v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-subtitle style="color: #00BFA5"><b>R$ {{ (parseFloat(item.preco.replace(',','.')) * item.quantidade).toFixed(2).replace('.',',') }}</b></v-list-item-subtitle>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                  <v-list dense style="padding: 0px">
                    <v-list-item style="padding: 0px">
                      <v-list-item-content style="padding: 0px">
                        <v-list-item-title>Total:</v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-subtitle style="color: #00BFA5"><b>R$ {{ detalhesCompra.valor }}</b></v-list-item-subtitle>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12">
                  <p style="margin: 0px; text-align: right"><em>Consumo realizado em {{ transformaData(detalhesCompra.created, 'DD/MM/YYYY') }} às {{ transformaData(detalhesCompra.created, 'HH:mm') }}</em></p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="imprimeConsumo()" color="teal" text>Reimprimir Pedido</v-btn>
              <v-btn @click="dialogoDetalhesConsumo = false" color="red" text>Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <Snackbar ref=chamaSnackbar />
    </v-container>

    <v-dialog persistent v-model="dialogoSolicitaPin" max-width="400px">
      <v-card>
        <v-card-title>Solicite a senha</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-otp-input id="pinTransacao" autofocus="true" length="4" color="#474d55" type="number" v-model="pinTransacao" v-if="situacao == 'ESTORNO'" @finish="criarEstorno"></v-otp-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialogoSolicitaPin = false">Fechar</v-btn>
          <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="criarEstorno" v-if="situacao == 'ESTORNO'">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';
  if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  export default {
    components: {
      Snackbar,
    },
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      dialogoDetalhesConsumo: false,
      dialogoSolicitaPin: false,
      pinTransacao: '',
      situacao: '',
      estornoObj: [],
      isLoading: false,
      tabela: {
        cabecalho: [
          { text: 'Consumidor', value: 'consumidor.nome' },
          { text: 'Turma', value: 'consumidor.turma' },
          { text: 'Valor', value: 'valor' },
          { text: 'Tipo', value: 'tipoTransacao' },
          { text: 'Atendente', value: 'atendente.nome?' },
          { text: 'Lojista', value: 'lojista.nome' },
          { text: 'Realizado em', value: 'created' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' }
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      detalhesCompra: {
          tipoTransacao: "CONSUMO",
          valor: "",
          "lojista": {
            "nome": "Pastel da Liberdade",
          },
          "atendente": {
            "nome": "Pastel 1",
          }
        },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndexCat: -1,
      editedIndexProd: -1,
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
      lojistaSelecionado: '',
      lojistas: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndexProd === -1 ? 'ADICIONAR NOVO PRODUTO' : 'EDITAR PRODUTO'
      },
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },

    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
      dialogoSolicitaPin() {
        if (this.dialogoSolicitaPin == true) {
          setTimeout(() => {
            document.getElementById('pinTransacao--0').focus()
          }, 400);
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN_PRODUTORA') {
        this.carregaLojistas()
      } else {
        this.carregaTransacoes()
      }
    },

    methods: {
      async carregaLojistas() {
        await axios.get(baseApiUrl + 'Lojistas?filter={"where":{"empresaId":"' + this.user.empresaId + '"}, "order":"nome ASC" ,"fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.lojistas = response.data
          }
        })
      },

      generatePDFDetails() {
        const docDefinition = {
              content: [
              { text: `Relatório de Transações - (${this.formatDate(this.dataInicio)} - ${this.horaInicio} à ${this.formatDate(this.dataFim)} - ${this.horaFim})`, style: 'header' },
                { text: `Valor Total do Período: ${this.campoSoma('valor').toString().replace('.',',')}`, style: 'transactionHeader' },
                // Loop através de todas as transações para criar as seções
                ...this.tabela.conteudo.map(transaction => ({
                  unbreakable: true,
                  margin: [0, 5, 0, 15], // Margem entre as transações
                  stack: [
                    {
                      text: `Transação: ${transaction.tipoTransacao}`,
                      style: 'transactionHeader'
                    },
                    {
                      text: `Consumidor: ${transaction.consumidor.nome}`,
                      style: 'transactionSubHeader'
                    },
                    {
                      text: `Turma: ${transaction.consumidor.turma || '-'}`,
                      style: 'transactionSubHeader'
                    },
                    {
                      text: `Valor Total: ${transaction.valor}`,
                      style: 'transactionSubHeader'
                    },
                    {
                      text: `Atendente: ${transaction.atendente == undefined ? 'Delivery' : transaction.atendente.nome}`,
                      style: 'transactionSubHeader'
                    },
                    {
                      text: `Lojista: ${transaction.lojista.nome}`,
                      style: 'transactionSubHeader'
                    },
                    {
                      text: `Data: ${this.formatDateHour(transaction.created)}`,
                      style: 'transactionSubHeader'
                    },
                    {
                      style: 'itemsTable',
                      table: {
                        widths: [150, 'auto', 100, 'auto'], // Larguras definidas para as colunas
                        body: [
                          [
                            // Cabeçalhos da tabela
                            { text: 'Descrição', style: 'tableHeader' },
                            { text: 'Preço', style: 'tableHeader' },
                            { text: 'Observação', style: 'tableHeader' },
                            { text: 'Quantidade', style: 'tableHeader' }
                          ],
                          // Dados dos itens
                          ...transaction.itens.map(item => [
                            { text: item.descricao, style: 'itemCell' },
                            { text: item.preco, alignment: 'right', style: 'itemCell' },
                            { text: item.observacao, style: 'itemCell' },
                            { text: item.quantidade.toString(), alignment: 'right', style: 'itemCell' }
                          ]),
                        ]
                      },
                      layout: 'lightHorizontalLines'
                    }
                  ]
                }))
              ],
              styles: {
                header: {
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 10]
                },
                transactionHeader: {
                  fontSize: 14,
                  bold: true,
                  margin: [0, 5, 0, 5]
                },
                transactionSubHeader: {
                  fontSize: 12,
                  italics: true,
                  margin: [0, 5, 0, 5]
                },
                tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  margin: [0, 5, 0, 5]
                },
                itemCell: {
                  margin: [0, 2, 0, 2], // Espaçamento dentro das células
                  fontSize: 10 // Tamanho da fonte para as células dos itens
                },
                itemsTable: {
                  margin: [0, 5, 0, 15]
                }
              },
              defaultStyle: {
                columnGap: 10
              }
            };



      pdfMake.createPdf(docDefinition).download(`Transacoes-${this.formatDate(this.dataInicio)}-${this.formatDate(this.dataFim)}.pdf`);
    },

    generatePDF(){
        const docDefinition = {
            content: [
            { text: `Relatório de Transações - (${this.formatDate(this.dataInicio)} - ${this.horaInicio} à ${this.formatDate(this.dataFim)} - ${this.horaFim})`, style: 'header' },
              { text: `Valor Total no Período: ${this.campoSoma('valor').toString().replace('.',',')}`, style: 'transactionHeader' },
              {
                style: 'transactionsTable',
                table: {
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
                  body: [
                    // Cabeçalhos da tabela
                    [
                    {
                      text: `Transação`,
                      style: 'tableHeader'
                    },
                    {
                      text: `Consumidor`,
                      style: 'tableHeader'
                    },
                    {
                      text: `Turma`,
                      style: 'tableHeader'
                    },
                    {
                      text: `Valor Total`,
                      style: 'tableHeader'
                    },
                    {
                      text: `Atendente`,
                      style: 'tableHeader'
                    },
                    {
                      text: `Lojista`,
                      style: 'tableHeader'
                    },
                    {
                      text: `Data`,
                      style: 'tableHeader'
                    }
                    ],
                    // Dados das transações
                    ...this.tabela.conteudo.map(t => [
                      t.tipoTransacao,
                      this.getFirstAndLastName(t.consumidor.nome),
                      t.consumidor.turma || '-',
                      { text: t.valor, alignment: 'left' },
                      t.atendente == undefined ? 'Delivery' : t.atendente.nome,
                      t.lojista.nome,
                      this.formatDateHour(t.created)

                    ]),
                  ]
                },
                layout: 'lightHorizontalLines',
                }
            ],
            styles: {
              header: {
                fontSize: 16,
                bold: true,
                margin: [0, 0, 0, 10]
              },
              transactionHeader: {
                  fontSize: 12,
                  bold: true,
                  margin: [0, 5, 0, 5]
                },
              tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'black',
                margin: [0, 5, 0, 5]
              },
              transactionsTable: {
                margin: [0, 20, 0, 0]
              }
            },
            defaultStyle: {
              columnGap: 10
            }
          };

          pdfMake.createPdf(docDefinition).download(`Transacoes-${this.formatDate(this.dataInicio)}-${this.formatDate(this.dataFim)}.pdf`);
      },

      getFirstAndLastName(fullName) {
          const nameParts = fullName.trim().split(/\s+/); // Split pelo espaço e remove espaços extras
          if (nameParts.length === 1) {
            return fullName; // Se tiver apenas um nome, retorna ele
          }
          return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`; // Retorna o primeiro e o último nome
        },

      async carregaTransacoes () {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        let url = ''

        if (this.user.tipo == 'ADMIN') {
          url = baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"or":[{"tipoTransacao":"CONSUMO"},{"tipoTransacao":"ESTORNO"}]},{"created":{"gte":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "include":["consumidor","atendente","lojista"]}&access_token='+sessionStorage.getItem('accToken')
        } else if (this.user.tipo == 'ADMIN_LOJISTA') {
          url = baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"lojistaId":"' + this.user.lojistaId + '"},{"or":[{"tipoTransacao":"CONSUMO"},{"tipoTransacao":"ESTORNO"}]},{"created":{"gte":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "include":["consumidor","atendente","lojista"]}&access_token='+sessionStorage.getItem('accToken')
        } else if (this.user.tipo == 'ADMIN_PRODUTORA') {
          url = baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"lojistaId":"' + this.lojistaSelecionado + '"},{"or":[{"tipoTransacao":"CONSUMO"},{"tipoTransacao":"ESTORNO"}]},{"created":{"gte":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}, "include":["consumidor","atendente","lojista"]}&access_token='+sessionStorage.getItem('accToken')
        }

        await axios.get(url)
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })
      },

      async imprimeConsumo(){
        let vm = this
        this.isLoading = true
          await axios.post(baseApiUrl + 'ExtratoCartoes/imprimirPedido?access_token=' + sessionStorage.getItem('accToken'), {"extratoId": this.detalhesCompra.id})
          .then(response => {
            if (response.data) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1","Pedido enviado para a impressora!","INFORMAÇÃO")
            }
          })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora
      },

      campoSoma(key) {
        // sum data in give key (property)
        // let total = this.tabela.conteudo.reduce((a, b) => (parseFloat(a) + parseFloat(b[key].replace(',','.'))).toFixed(2), 0)

        const total = this.tabela.conteudo.reduce((acc, obj) => {
          if (obj.tipoTransacao == 'CONSUMO' && !obj.estornado) {
            return (parseFloat(acc) + parseFloat(obj[key].replace(',','.'))).toFixed(2);
          }
          return acc;
        }, 0);

        return 'R$ ' + total
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      exibeDetalhes(item) {
        this.detalhesCompra = Object.assign({}, item)
        this.dialogoDetalhesConsumo = true
      },

      async abreConfirmacaoEstorno(item) {
        if (!item.estornado) {
          var r = confirm('Deseja ESTORNAR o extrato com o valor de: ' + item.valor + '?')
          if (r == true) {
            this.situacao = 'ESTORNO'
            this.estornoObj = item
            this.dialogoSolicitaPin = true
          }
        } else {
          this.$refs.chamaSnackbar.snack("orange","Transação já estornada anteriormente","ATENÇÃO")
        }
      },

      async criarEstorno() {
        let vm = this
        this.isLoading = true
        let dados = {
          "pin": this.pinTransacao,
          "extratoId": this.estornoObj.id,
          "atendenteId": this.user.id,
          "lojistaId": this.estornoObj.lojistaId,
        }

        await axios.post(baseApiUrl + 'ExtratoCartoes/estornarTransacao?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            this.dialogoSolicitaPin = false
            this.carregaTransacoes()
            this.isLoading = false
            this.estornoObj = []
            this.situacao = ''
            this.pinTransacao = ''
            vm.$refs.chamaSnackbar.snack("#0288D1", "Estorno salvo!", "INFORMAÇÃO")
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "DESCULPE")
        })
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else if (dataA >= dataC && dataB < dataA)
          comparison = -1; */
        else if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      transformaData(data, formato) {
        let date = moment(data).utc().format(formato);
        return date
      },

      formatarCanalPedido(canal) {
        if (canal == 'TOTEM') {
          return 'Totem'
        } else if (canal == 'DELIVERY') {
          return 'Delivery'
        }
      },

      async enviarMensagem(pedidoId) {
        let vm = this
        this.isLoading = true

        await axios.post(baseApiUrl + 'ExtratoCartoes/enviarMensagem?access_token=' + sessionStorage.getItem('accToken'), {"extratoCartaoId": pedidoId})
        .then(response => {
          vm.$refs.chamaSnackbar.snack("#0288D1", response.data, "INFORMAÇÃO")
        })
        .catch(error => {
          vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "DESCULPE")
        })
        
        this.isLoading = false
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
